module.exports = __webpack_public_path__ + "static/img/ic_ad_cs.6b6e08d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_ad_cs.png
// module id = UUBn
// module chunks = 0